import { useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { getTheme, Theme } from '../theme';
import NotificationBody, { NotificationBodyProps } from './NotificationBody';

var idCounter = 1;

export const _UINotificationController = {
    notifications: [] as NotificationBodyProps[],
    notificationsById: {} as { [id: NotificationBodyProps['id']]: NotificationBodyProps },
    subscriptions: [] as (() => void)[],
    subscribe(callback: () => void): () => void {
        this.subscriptions.push(callback);
        return () => this.subscriptions = this.subscriptions.filter(subscription => subscription !== callback);
    },
    add(props: Omit<NotificationBodyProps, 'id'>): number {
        // if (this.notifications.some(tooltip => tooltip.target === props.target)) return 0;
        (props as NotificationBodyProps).id = idCounter++;
        const notification = props as NotificationBodyProps;
        this.notifications.push(notification);
        this.notificationsById[notification.id] = notification;
        this.push();
        return notification.id;
    },
    update(id: NotificationBodyProps['id'], props: { [key in keyof NotificationBodyProps]?: NotificationBodyProps[key] }) {
        if (!this.notificationsById[id]) return;
        (Object.keys(props) as (keyof NotificationBodyProps)[]).forEach((key) => (this.notificationsById[id][key] as any) = props[key]);
    },
    remove(id: NotificationBodyProps['id']) {
        this.notifications = this.notifications.filter(notification => notification.id !== id);
        delete this.notificationsById[id];
        this.push();
    },
    controllerRender: null as (() => void) | null,
    push() {
        this.subscriptions.forEach((subscription) => subscription());
        if (this.controllerRender) this.controllerRender();
    }
}

export default function NotificationController({ }) {
    const [notifications, setNotifications] = useState<NotificationBodyProps[]>([]);
    const [theme,] = useState<Theme>(getTheme);
    function render() {
        setNotifications([..._UINotificationController.notifications])
    }
    _UINotificationController.controllerRender = render;

    if (!notifications || !notifications.length) return null;

    return (
        <ThemeProvider theme={theme}>
            <Wrapper>
                {/* {notifications.map(notification => <NotificationBody key={notification.id} {...notification}></NotificationBody>)} */}
                {notifications.length && <NotificationBody  {...notifications[0]}></NotificationBody>}
            </Wrapper>
        </ThemeProvider>
    )
}

const Wrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 0;
`